<template>
  <v-layout>
    <v-layout
      v-if="!packageItems.length"
      row
    >
      <h2 class="mt-2 ml-2 subheading font-weight-bold">
        Добавить данные по грузу
      </h2>
      <v-btn
        class="mt-2 plus-button"
        :disabled="readonly"
        @click="addPackage"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-layout>
    <v-layout
      v-else
      column
    >
      <v-layout v-show="!isShipping">
        <v-text-field
          v-model="client"
          label="Клиент"
          outline
          hide-details
          readonly
          height="42"
          class="ma-2"
        />
        <v-text-field
          v-model="clientAlias"
          label="Клиент по документам"
          outline
          hide-details
          readonly
          height="42"
          class="ma-2"
        />
        <v-text-field
          v-model="factory"
          label="Продавец"
          outline
          hide-details
          readonly
          height="42"
          class="ma-2"
        />
      </v-layout>
      <v-layout v-show="!isShipping">
        <v-text-field
          v-model="productDescription"
          label="Описание товаров"
          outline
          hide-details
          readonly
          height="42"
          class="mx-2 mt-2 mb-5"
        />
        <v-text-field
          v-model="weight"
          label="Вес брутто, кг"
          outline
          hide-details
          readonly
          height="42"
          class="mx-2 mt-2 mb-5"
        />
      </v-layout>
      <v-flex
        v-for="(packageItem, index) in packageItems"
        :key="index"
      >
        <v-layout align-center>
          <app-reference
            v-model="packageItem.packageType"
            label="Тип упаковки*"
            :rules="[v => !!v || '']"
            :outline="true"
            :height-field="44"
            resource="package-types"
            component-name="PackageType"
            required
            :error="checkMissingElement(packageItem.packageType, true)"
            :readonly="readonly"
            :disable-add="true"
            :scroll-value="scrollValue"
            class="ma-2"
            @input="changePackageType(index, packageItem.packageType)"
          />
          <DecimalEditor
            v-model="packageItem.length"
            label="Длина, м"
            :scale="2"
            :height-field="44"
            :readonly="readonly"
            :disabled="
              packageItem.packageType &&
                packageItem.packageType.id == packageTypes.PalletEuro.id
            "
            class="ma-2"
            @input="changePackage"
          />
          <DecimalEditor
            v-model="packageItem.width"
            label="Ширина, м"
            :scale="2"
            :height-field="44"
            :readonly="readonly"
            :disabled="
              packageItem.packageType &&
                packageItem.packageType.id == packageTypes.PalletEuro.id
            "
            class="ma-2"
            @input="changePackage"
          />
          <DecimalEditor
            v-model="packageItem.height"
            label="Высота, м"
            :scale="2"
            :height-field="44"
            :readonly="readonly"
            :disabled="
              packageItem.packageType &&
                packageItem.packageType.id == packageTypes.Roll.id
            "
            class="ma-2"
            @input="changePackage"
          />
          <DecimalEditor
            v-model="packageItem.quantity"
            label="Количество*"
            :scale="0"
            :height-field="44"
            :rules="[v => !!v || '']"
            required
            :error="checkMissingElement(packageItem.packageType, true)"
            :readonly="readonly"
            class="ma-2"
            @input="changePackage"
          />
          <MenuRowActions
            v-if="!readonly"
            :list="rowActions"
            :value="packageItem"
            :index="index"
            @add="addPackage"
            @remove="removePackage(index)"
          />
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>
<script>
import { getPackageType } from "../../../../backend/shippingsApi.js";
import { packages } from "../../../package-types/packages.js";

export default {
  props: [
    "value",
    "indicateOfMissingValue",
    "readonly",
    "scrollValue",
    "shippingInfo",
    "isShipping",
  ],
  data() {
    return {
      addPackagingForm: false,
      packageItems: [],
      client: "",
      factory: "",
      clientAlias: "",
      productDescription: "",
      weight: 0,
    };
  },
  computed: {
    rowActions() {
      return [
        {
          title: "Добавить",
          name: "add",
          action: this.addPackage,
          type: "icon",
          icon: "add",
          disabled: !this.packageItems.find(c => c.packageType && c.quantity),
        },
        {
          title: "Удалить",
          name: "remove",
          action: this.removePackage,
          type: "icon",
          icon: "delete",
        },
      ];
    },
    packageTypes() {
      return packages;
    },
  },
  watch: {
    value: {
      handler(val) {
        if (!val || !val.length) {
          return;
        }
        this.packageItems = val;
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    if (this.isShipping) {
      return;
    }
    this.client = this.shippingInfo?.client?.title || "";
    this.clientAlias = this.shippingInfo?.clientAlias;
    this.factory = this.shippingInfo?.factory?.title || "";
    this.productDescription = this.shippingInfo?.productDescription;
    this.weight = this.shippingInfo?.weight;
  },
  methods: {
    addPackage() {
      this.packageItems.push({
        packageType: null,
        quantity: 0,
        length: 0,
        width: 0,
        height: 0,
      });
    },
    removePackage(index) {
      this.packageItems.splice(index, 1);
    },
    async changePackageType(index, value) {
      if (!value) {
        this.packageItems.forEach((p, ind) => {
          if (ind === index) {
            p.packageType = null;
            p.width = 0;
            p.length = 0;
            p.height = 0;
            p.quantity = 0;
          }
        });
        return;
      }
      const packageType = await getPackageType(value.id);
      this.packageItems.forEach((p, ind) => {
        if (ind === index) {
          p.packageType = packageType.packageType;
          p.width =
            packageType.packageType?.id == this.packageTypes.PalletEuro.id
              ? packageType.width
              : 0;
          p.length =
            packageType.packageType?.id == this.packageTypes.PalletEuro.id
              ? packageType.length
              : 0;
          p.height = 0;
          p.quantity = 0;
        } else {
          p;
        }
      });
      this.changePackage();
    },
    changePackage() {
      this.$emit("change", this.packageItems);
    },
    checkMissingElement(value, required) {
      if (!this.indicateOfMissingValue) {
        return;
      }
      if (!value && !required) {
        const color = "#ef5350";
        return color;
      }
      if (!value && required) {
        return true;
      }
    },
  },
};
</script>
